<!-- překryv při načítání; barva závoje z tokenu gov tématu, spinner stylují Optimus/téma; třídu overlay používá e2e -->
<div
  class="overlay absolute top-0 left-0 w-full h-full z-1000 flex justify-center items-center bg-[color-mix(in_srgb,var(--background-overlay-page)_55%,transparent)]">
  <p-progress-spinner class="w-16 h-16" ariaLabel="loading"></p-progress-spinner>
</div>
